import React from 'react';

import Drawer from 'common/components/Drawer';
import { useFilterDrawer } from '../context/FilterDrawerContext';
import CategoryFiltersDrawerContent from './CategoryFiltersDrawerContent';

export const FilterDrawerShell = () => {
  const { isOpen, closeDrawer, ariaLabelId } = useFilterDrawer();

  return (
    <div data-corgi-id="category-filters-drawer">
      <Drawer
        isLeftOpener
        isOpen={isOpen}
        ariaLabelledby={ariaLabelId}
        onBackdropClick={closeDrawer}
      >
        {isOpen && <CategoryFiltersDrawerContent />}
      </Drawer>
    </div>
  );
};
